var _circle, _circle2, _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 98 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 49,
    fill: "#fff",
    fillOpacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 49,
    r: 40,
    fill: "#3D41B6",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.75 64.75V38.682L34.841 50.594a2.25 2.25 0 11-3.181-3.184l15.75-15.75c.152-.153.327-.283.517-.387l.042-.022h.014l.032-.025h.045l.04-.038a2.25 2.25 0 011.8 0l.04.018h.019l.026.02.032.016h.014l.042.022c.19.104.365.234.518.387l15.75 15.75a2.25 2.25 0 11-3.182 3.184l-11.91-11.903V64.75a2.25 2.25 0 11-4.499 0z",
    fill: "#fff",
    id: "upload-circle_svg__arrow"
  })));
}
export default SvgUploadCircle;